import { ILevelBenefits, IWalletTierBenefits } from "@common-types";
import { Spin } from "antd";
import React from "react";
import { FormattedMessage } from "react-intl";

interface CreditRowProps {
  title: string;
  linkText: string;
}

const getColor = (idx: number) => {
  if (idx == 0) {
    return 'emerald';
  }
  if (idx == 1) {
    return 'diamond';
  }
  if (idx == 2) {
    return 'ruby';
  }
  return 'emerald';
};

const LevelBenefits: React.FC<any> = (props) => {
  const { loading, benefits } = props;
  return (
    <Spin spinning={loading}>
      <div className="card shadow-sm border mb-5">
        <div className="card-header bg-transparent border-bottom">
          <h4 className="card-header-title"><i className="bi bi-list-check me-2"></i><FormattedMessage id="level.benefits" /></h4>
        </div>

        <div className="card-body vstack">

          {benefits.map((benefit: IWalletTierBenefits, idx: number) => (
            <div className="row mb-4" key={idx} tabIndex={idx}>
              <div className="col-12">
                <div className={`h5 text-tier-${idx+1} fw-medium"`}><i className="bi bi-unlock"></i> {benefit.tierName}</div>
                {benefit.levels.map((level: ILevelBenefits, i) => (
                  <div className="card border pt-0 mb-2 flex-grow-1" key={i} tabIndex={i}>
                    <div className="card-body px-3 py-2">
                      <div className="d-md-flex justify-content-md-between align-items-center">
                        <div className="d-flex align-items-center">
                          <div className="avatar flex-shrink-0">
                            <div className={`avatar-img rounded-circle bg-tier-${idx+1}`}><span className="position-absolute text-white top-50 start-50 translate-middle fw-bold"><i className={`${benefit.active ? '' : 'bi bi-lock'}`}></i>{benefit.active ? level.sign : ''}</span></div>
                          </div>
                          <div className="ms-2">
                            <h6 className="card-title mb-0">{level.title}</h6>
                            <ul className="nav nav-divider small">
                              <li className="nav-item">{level.subTitle}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Spin>
  );
};

export default LevelBenefits;
